module.exports = __webpack_public_path__ + "img/feature_buy_my.f10fbc78.png";